export const errorTypes = new Map<string, string>([
  ['INTERNAL', 'İç'],
  ['EXTERNAL', 'Dış'],
]);

export enum ErrorType {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL',
}
